module.exports = __webpack_public_path__ + "static/media/unemp-arrow.05ad3755.svg";